import { useContext } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { ProjectActionsContextMenuPopper } from '@/components/GroupProject/ProjectActionsContextMenu';
import { useProjectActions, useProjectActionsValidity } from '@/containers/GroupProject/hooks';
import { ProjectAction } from '@/enums';
import { ProjectStateLoadingContext } from './Context';
import { ManageAccessButton } from './Header.Access';
import styles from './style/ProjectActions.module.css';
import { DiscoverInsights } from '@trinity/chat-components/components/DiscoverInsights/DiscoverInsights.js';

type Props = unknown;

export const Actions = (props: Props) => {
  const isLoading = useContext(ProjectStateLoadingContext);

  return isLoading
    ? <SkeletonActions />
    : <InteractiveActions />;
};

Actions.displayName = 'Project.Actions';

const InteractiveActions = (props: Props) => {
  return (
    <div className={styles.root}>
      <DiscoverInsights className={styles.discover} />
      <ManageAccessButton />
      <ProjectActionsContextMenuPopper className={styles.contextMenu} />
    </div>
  );
};

InteractiveActions.displayName = 'Project.Actions.Interactive';

const SkeletonActions = (props: Props) => {
  return (
    <div className={styles.actions}>
      <Skeleton
        height={30}
        variant="rounded"
        width={70} />
      <Skeleton
        height={30}
        variant="rounded"
        width={70} />
      <Skeleton
        height={30}
        variant="rounded"
        width={70} />
    </div>
  );
};

SkeletonActions.displayName = 'Project.Actions.Skeleton';